/// <reference path="../../lib/app.d.ts" />

import {ChatClientUI} from "../ui/view";
import {Application} from "../application/application";
import {
	SecurionPayChatEventHandler, SecurionPayChatHandler,
	SecurionPayChatNotificationEventParams
} from "../application/interfaces";
import {TemplateEngine} from "../lib/template-engine";
import {ToastManager} from "../ui/toast-manager";
import {Translator} from "../utils/translator";
import {Storage} from "../lib/storage";
import webAPI from "../api/web-api-2";
import logging from "../utils/log";
import {Collection} from "../lib/event-interface";
module InputUtils
{
	export function unformatWithCursor(sourceValue, cursor)
	{
		let value = "", char, i;
		for (i = 0; i < sourceValue.length; i++) {
			char = sourceValue.charAt(i);
			if (isNaN(parseInt(char, 10))) {
				if (i < cursor) cursor--;
			}
			else {
				value += char;
			}
		}
		return {value, cursor};
	}

	export function formatWithCursor(sourceValue, cursor, groupBy, sep = " ")
	{
		let value = "";
		for (let i = 0; i < sourceValue.length; i++) {
			if (i % groupBy === 0 && i > 0) {
				value += sep;
				if (cursor > i) cursor++;
			}
			value += sourceValue.charAt(i);
		}
		return {value, cursor};
	}
}

export interface SpParams
{
	autopay: boolean,
	quickbuy: boolean,

	defaultAmount: number,

	publicKey : string;
	apiURL : string;

	autopayMin: number;
	autopayAmount: number;

	cardType: string;
	last4: string;

	ajaxURL : string;
}

export interface MethodData
{
	items : TopupItem[];
	code ?: string;
	url ?: string;
}

export interface TopupParams
{
	currencies: any;
	securionPay ?: SpParams,
	methods ?: {
		[ key : string ] : MethodData
	};
}

export interface Promo {
	type    : string;
	name    : string;
	params? : Object;
	getStart() : number;
	getEnd() : number;
	getAmount(amount : number) : number;
}

interface TopupItem
{
	phone?: string;
	credit: number;
	price: number;
	currency: string;
}

export class TopupManager
{
	onAutoPayChange: any;
	onQuickBuChange: (enabled: boolean) => any;
	onPromoChange: (promo : Promo) => any;
	// private ui : ChatClientUI;
	private securionPayHandler: SecurionPayChatHandler;
	currentPushPromo: any;
	currentPromo: Promo;

	public constructor(private params: TopupParams, public app : Application)
	{
		this.params.methods = Object.assign({firstcredit: this.params.methods.creditcard}, this.params.methods);
	}

	public getCurentPromo()
	{
		return this.currentPromo;
	}

	public getSecurionPayEventHandler() : SecurionPayChatEventHandler
	{
		let topup = this;

		let onUpdateOrSet = (promo => {
			if (promo && promo.name == "echh" && topup.app.view.isVisible())
			{
				topup.app.view.streamNotificationManager.clearByTag("echh");

				let link = $("<a href='#' />").text(topup.app.translator.t("promo_notification_echh_link"))
					.on("click", () => {
						topup.app.view.topupPanel.show(true);
						topup.app.view.streamNotificationManager.clearByTag("echh");
					});

				topup.app.view.streamNotificationManager.add(
					$("<span />").append(
						topup.app.translator.t("promo_notification_echh_desc").replace("{{bonus}}", promo.params.percent), " ", link
					),
					"normal",
					"echh",
					20 * 1000,
					null
				);

				if (promo.getEnd()) {
					topup.app.view.bottomPanel.creditButtonCountdown(promo.name, promo.getEnd());
				}
			}

			if (promo === null) {
				topup.app.view.streamNotificationManager.clearByTag("echh");
				topup.app.view.bottomPanel.creditButtonCountdown(null);
			}
		});

		return {

			showNotification(message : string, params : SecurionPayChatNotificationEventParams) : void
			{
				logging.log("[TopupManager:Callbacks]", "showNotification", message, params);
				topup.app.view.toastManager.push(message, {timeout: 7000});
			},
			setCurrentPromo(promo : Promo) : void
			{
				logging.log("[TopupManager:Callbacks]", "setCurrentPromo", promo);
				topup.app.view.topupPanel.promoSet(promo);

				onUpdateOrSet(promo);

				if (topup.onPromoChange) topup.onPromoChange(promo);
			},

			promoUpdated(promo : Promo) : void
			{
				logging.log("[TopupManager:Callbacks]", "promoUpdated", promo);
				topup.currentPromo = promo;
				topup.app.view.topupPanel.promoUpdated(promo);

				onUpdateOrSet(promo);

				if (topup.onPromoChange) topup.onPromoChange(promo);

			},
			updatePushPromo(data : any) : void
			{
				if (data === false && topup.currentPushPromo)
				{
					topup.currentPushPromo = null;

					// It means the promo needs to be disabled
					topup.app.view.streamNotificationManager.clearByTag("push");
					topup.app.view.bottomPanel.creditButtonCountdown(null);
				}
				else if (data === true)
				{
					// It means the promo is already started and still running. No operations needed,
					// it's just mentioned here to make things obvious.
				}
				else if (typeof data === "object")
				{
					topup.currentPushPromo = data;

					let link = $("<a href='#' />").text(topup.app.translator.t("promo_notification_push_link"))
						.on("click", () => {
							topup.app.view.topupPanel.pushPromo(topup.currentPushPromo);
							topup.app.view.streamNotificationManager.clearByTag("push");
						});
					let item = topup.getItem("creditcard", topup.currentPushPromo.credits);
					let formattedPrice = topup.formatPrice(item.price, item.currency);

					let text = topup.app.translator.t("promo_notification_push_desc", {
						credits: parseInt(topup.currentPushPromo.credits) + parseInt(topup.currentPushPromo.extraCredits),
						amount: formattedPrice
					});

					topup.app.view.streamNotificationManager.add(
						$("<span />").append(
							text, " ", link
						),
						"normal",
						"push",
						10 * 60000,
						null
					);

					// If data is an object then it's the data of a new promotion
					topup.currentPushPromo = data;
					topup.app.view.bottomPanel.setCreditButtonAction("topup_push");
					topup.app.view.bottomPanel.creditButtonCountdown("push", Date.now() + 10 * 60000);
				}
			}
		}
	}

	public setSecurionPayHandler(handler : SecurionPayChatHandler)
	{
		this.securionPayHandler = handler;
	}

	public getSecurionPayHandler() : SecurionPayChatHandler
	{
		return this.securionPayHandler;
	}

	public formatPrice(amount: number, currency: string)
	{
		// logging.log("formatPrice", amount, currency);
		let tmpl = this.params.currencies[currency.toLowerCase()];
		if (!tmpl) {
			tmpl = this.params.currencies["default"];
		}

		let amount2 = Math.round(amount * 100) / 100;
		let intAmount = Math.round(amount);

		return tmpl
			.split("{{value}}").join(amount2)
			.split("{{intvalue}}").join(intAmount)
			.split("{{currency}}").join(currency);
	}

	getData(method: string): MethodData
	{
		switch (method) {
			// case "creditcard":
			// 	return {
			// 		params: this.params.securionPay,
			// 		items: this.params.methods[method].items
			// 	};

			default:
				return this.params.methods[method];

		}
	}

	getItem(method: string, amount: number): TopupItem
	{
		for (let item of this.getData(method).items) {
			if (item.credit == amount) {
				return item;
			}
		}
	}

	getMethods()
	{
		return Object.keys(this.params.methods);
	}

	//noinspection JSMethodCanBeStatic
	formatPhone(phone: string)
	{
		let m = phone.match(/^(\d{2})(\d{2})(\d{3})(\d+)$/);
		return m ? m[1] + " " + m[2] + " " + m[3] + " " + m[4] : phone;
	}

	public setQuickBuy(enabled : boolean)
	{
		this.params.securionPay.quickbuy = enabled;
		if (this.onQuickBuChange) this.onQuickBuChange(enabled);
	}

	public setOnQuickBuyChange(cb : (enabled: boolean) => any)
	{
		this.onQuickBuChange = cb;
	}

	public setOnAutoPayChange(cb : (enabled: boolean) => any)
	{
		this.onAutoPayChange = cb;
	}

	public setOnPromoChange(cb : (promo : Promo) => any)
	{
		this.onPromoChange = cb;
	}

	public isQuickBuyEnabled()
	{
		return this.params.securionPay.quickbuy;
	}

	public isAutoPayEnabled()
	{
		return this.params.securionPay.autopay;
	}

	setAutoPay(enabled: boolean)
	{
		this.params.securionPay.autopay = enabled;
		this.onAutoPayChange(enabled);
	}
}

abstract class TopupPanelModule
{
	protected TAG = "[TopupPanelModule]";

	public constructor(protected $root: JQuery,
	                   protected tmpl: TemplateEngine,
	                   protected manager: TopupManager,
	                   protected toast: ToastManager,
	                   protected t: Translator,
	                   protected storage: Storage,
	                   protected event : Collection,
	                   protected credits: number,
	                   protected special : any,
	                   protected onClose: () => void)
	{
	}

	abstract init();

	initCommon()
	{
		this.$root.find(".sxcct-window-close").on('click', () =>
		{
			this.onClose();
		});

		this.$root.find("[data-tooltip]").mouseenter((e) =>
		{
			let scrollOffset = 0;
			// $inner[0].scrollTop;

			let $i = $(e.currentTarget);
			let top = scrollOffset + $i.position().top + $i.height() / 2 - 30;
			let left = $i.position().left + $i.width() / 2 + 30;
			let msg = $i.data("tooltip");

			this.showTooltip(left, top, msg);
		});

		this.$root.find("[data-tooltip]").mouseleave(() =>
		{
			this.clearTooltip();
		});
	}

	showTooltip(left: number, top: number, msg: string)
	{
		logging.log(this.TAG, "showTooltip", left, top, msg);
		this.$root
			.find(".sxcct-tooltip")
			.css({top, left})
			.text(msg)
			.addClass("sxc-visible");
	}

	clearTooltip()
	{
		this.$root
			.find(".sxcct-tooltip")
			.removeClass("sxc-visible");
	}

	destroy()
	{
		this.$root.empty();
	}

	onResize()
	{

	}

	//noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
	updatePromo(promo: Promo)
	{
		// Noop. Implement if needed
	}
}

export class TopupPanelModuleQuickBuy extends TopupPanelModule
{
	init()
	{
		// We cheat. This module has no interface. If it is initialized, the transaction happens automatically.
		this.manager.getSecurionPayHandler().doQuickBuy(this.credits, null, (success, data) =>
		{
			this.event.trigger("topup_attempt");

			if (success) {
				this.event.trigger("topup_successful");
				this.toast.push(data, {timeout: 7000, instant: true});
			} else {
				this.event.trigger("topup_failed");
				this.toast.push(data, {timeout: 7000, instant: true, strong: true});
			}
		});
		this.onClose();
	}

	destroy()
	{

	}
}

export class TopupPanelModuleCryptoCurrency extends TopupPanelModule
{
	init()
	{
		let creditsCalculated = this.credits;
		let item = this.manager.getItem("cryptocurrency", this.credits);
		let formattedPrice = this.manager.formatPrice(item.price, item.currency);
		// let phoneno = this.manager.formatPhone(item.phone);

		let $module = this.tmpl.render(
			"topup-module-cryptocurrency",
			{
				creditsCalculated, formattedPrice
			});

		this.$root.empty().append($module);

		this.$root.find(".sxcct-window-buttons button").click(() => {
			window.open(this.manager.getData("cryptocurrency").url + "?amount=" + this.credits , '_blank');
			this.onClose();
		})
	}
}

export class TopupPanelModuleCreditCard extends TopupPanelModule
{
	protected isE : boolean = false;
	protected $form: JQuery;

	init()
	{
		let credits = parseInt(this.credits.toString());
		if (this.special && this.special.ecp ) {
			credits += parseInt(this.special.ecp.toString());
		}

		if (this.special && this.special.firstcredit ) {
			credits += parseInt(this.special.firstcredit.toString());
		}

		if (this.special && this.special.echh ) {
			credits += parseInt(this.special.echh.toString());
		}

		let creditsCalculated = credits;
		let item = this.manager.getItem("creditcard", this.credits);
		let formattedPrice = this.manager.formatPrice(item.price, item.currency);

		let autpayLimitCalculated = 500;
		let autpayTopupCalculated = 1000;

		let $module = this.tmpl.render(
			this.isE ? "topup-module-creditcard-e" : "topup-module-creditcard",
			{creditsCalculated, autpayLimitCalculated, autpayTopupCalculated, formattedPrice});

		this.$root.empty().append($module);

		this.$root.find(".sxcct-show-cvv").mouseenter((e) =>
		{
			let scrollOffset = 0;
			// $inner[0].scrollTop;

			let $i = $(e.currentTarget);
			let top = scrollOffset + $i.position().top + $i.height() / 2 - 30;
			let left = $i.position().left + $i.width() / 2 + 30;

			this.$root
				.find(".sxcct-cvv-card")
				.css({top, left})
				.addClass("sxc-visible");
		});

		this.$root.find(".sxcct-show-cvv").mouseleave(() =>
		{
			this.$root.find(".sxcct-cvv-card").removeClass("sxc-visible");
		});

		this.$form = this.$root.find("form");

		this.$form.find("input").on("change keyup blur", (e) =>
		{
			this.inputChange($(e.currentTarget));
		});

		let submitting = false;

		this.$form.on("submit", (e) =>
		{
			e.preventDefault();

			if (submitting) return;
			submitting = true;

			let name = this.$form.find("[name=name]").val().toString();
			let email = this.$form.find("[name=email]").val().toString();
			let card = this.$form.find("[name=number]").val().toString();
			let expMonth = this.$form.find("[name=exp-month]").val().toString();
			let expYear = this.$form.find("[name=exp-year]").val().toString();
			let cvv = this.$form.find("[name=cvv]").val().toString();
			let quickBuy = this.$form.find("[name=quickbuy]").is(":checked");
			let autoPay = this.$form.find("[name=autopay]").is(":checked");
			let amount = this.credits;

			const onReady = (success, data) =>
			{
				submitting = false;
				this.event.trigger("topup_attempt");

				if (success)
				{
					logging.log(this.TAG, "Transaction successful", data);

					if (quickBuy) {
						this.manager.setQuickBuy(true);
					}

					if (quickBuy) {
						this.manager.setAutoPay(true);
					}
					this.event.trigger("topup_successful");

					this.toast.push(data, {timeout: 7000, instant: true});
					this.onClose();
				}
				else
				{
					logging.log(this.TAG, "Transaction failed", data);
					this.event.trigger("topup_failed");

					// Map received field name to ours
					let field = null;

					if (field) {
						switch (data.field) {
							case "cvc": field = "cvv"; break;
							default: field = data.field;
						}
					}

					this.showError(data.message, field);

					//
					// } else {
					// 	this.showError("test");
					// }
				}

			};

			this.manager.getSecurionPayHandler().doPurchase(amount, name, email, card, expYear, expMonth, cvv, quickBuy, autoPay, onReady);
		});


		if (this.isE)
		{
			this.$form.find("[name=quickbuy]")
				.prop("checked", true);
			this.$form.find("[name=autopay]")
				.prop("checked", true);
		}
		else
		{
			let quickbuy = this.storage.get("sxcc_topup_quickbuy_ticked", "");
			let autopay = this.storage.get("sxcc_topup_autopay_ticked", "");

			this.$form.find("[name=quickbuy]")
				.prop("checked", quickbuy == "1");
			this.$form.find("[name=autopay]")
				.prop("checked", autopay == "1");
		}
	}

	showError(err, errSource = null)
	{
		logging.log(this.TAG, "showError", err, errSource);
		if (err)
		{
			this.$root.find(".sxcct-window-buttons").hide();

			this.$root.find(".sxcct-window-errors").addClass("sxc-visible");

			let errID = "topup_creditcard_error_" + err;
			let errTXT = this.t.t(errID);
			if (errTXT === errID) errTXT = err;

			this.$root.find(".sxcct-window-errors .sxcct-err").show().text(errTXT);

			if (errSource)
			{
				this.$form.find("input").removeClass("sxcct-err");
				this.$form.find("input[name=" + errSource + "]").addClass("sxcct-err");
			}

			this.$root.one("click", () => {
				this.showError(null);
			})
		}
		else
		{
			this.$root.find(".sxcct-window-errors").removeClass("sxc-visible");
			this.$root.find(".sxcct-window-buttons").show();
			this.$form.find("input").removeClass("sxcct-err");
		}
	}

	inputChange($input)
	{
		let input = $input[0]  as HTMLInputElement;
		let name = $input.attr("name");

		logging.log("Input change (" + name + ": ", input);
		// Handle input formatting
		switch (name) {

			case "number":
				let ufn = InputUtils.unformatWithCursor(input.value, input.selectionStart);
				let fn = InputUtils.formatWithCursor(ufn.value, ufn.cursor, 4);
				input.value = fn.value;
				input.selectionStart = input.selectionEnd = fn.cursor;
				// this.$shadowForm.find("[name=" + name + "]").val(fn.value).change();
				break;

			case "expYear":
				if(input.value.length === parseInt(input.attributes["maxlength"].value)){
					$(input).closest("form").find("input[name='cvc']").focus();
				}
			case "expMonth":
				let ufx = InputUtils.unformatWithCursor(input.value, input.selectionStart);
				input.value = ufx.value;
				input.selectionStart = input.selectionEnd = ufx.cursor;
				if(input.value.length === parseInt(input.attributes["maxlength"].value)){
					$(input).parent().find("input[name='expYear']").focus();
				}
				break;
            case "exp-month":
                let ufx2 = InputUtils.unformatWithCursor(input.value, input.selectionStart);
                input.value = ufx2.value;
                input.selectionStart = input.selectionEnd = ufx2.cursor;
                if(input.value.length === parseInt(input.attributes["maxlength"].value)){
                	$(input).parent().find("input[name='exp-year']").focus();
                }
                break;
			case "exp-year":
				if(input.value.length === parseInt(input.attributes["maxlength"].value)){
					$(input).closest("form").find("input[name='cvv']").focus();
				}
				break;
			case "cvc":
				let cfx = InputUtils.unformatWithCursor(input.value, input.selectionStart);
				input.value = cfx.value;
				input.selectionStart = input.selectionEnd = cfx.cursor;
				// this.$shadowForm.find("[name=" + name + "]").val(cfx.value).change();
				break;
            case "cvv":
                let cvv = InputUtils.unformatWithCursor(input.value, input.selectionStart);
                input.value = cvv.value;
                input.selectionStart = input.selectionEnd = cvv.cursor;
                // this.$shadowForm.find("[name=" + name + "]").val(cfx.value).change();
                break;
			case "quickbuy":

				if (this.isE) break;

				// this.$shadowForm.find("[name=store_card]").prop("checked", $input.is(":checked"));
				this.storage.set("sxcc_topup_quickbuy_ticked", $input.is(":checked") ? "1" : "");

				if ($input.is(":not(:checked)")) {
					this.$form.find("[name=autopay]").prop("checked", false);
					this.storage.set("sxcc_topup_autopay_ticked", "");
					// this.$shadowForm.find("[name=enable_autobuy]").prop("checked", false);
				}
				break;

			case "autopay":

				if (this.isE) break;

				// this.$shadowForm.find("[name=enable_autobuy]").prop("checked", $input.is(":checked"));
				this.storage.set("sxcc_topup_autopay_ticked", $input.is(":checked") ? "1" : "");

				if ($input.is(":checked")) {
					this.$form.find("[name=quickbuy]").prop("checked", true);
					this.storage.set("sxcc_topup_quickbuy_ticked", "1");
					// this.$shadowForm.find("[name=store_card]").prop("checked", true);
				}
				break;

			default:
			// this.$shadowForm.find("[name=" + name + "]").val($input.val()).change();
		}
	}
}

export class TopupPanelModuleCreditCardE extends TopupPanelModuleCreditCard
{
	// noinspection JSUnusedGlobalSymbols
	protected isE : boolean = true;
}

export class TopupPanelModuleFirstCredit extends TopupPanelModuleCreditCard
{
}

export class TopupPanelModulePhoneHu extends TopupPanelModule
{
	retryTimer: number;
	private code = "";
	private cancelCodeUpdate = false;
	init()
	{
		this.render();
		this.updateCode();
	}

	updateCode()
	{
		webAPI.get("member/topup/getPhoneHuCode", {}).then((r : any) => {
			if (this.cancelCodeUpdate) return;
			if (r && "success" in r && r.success) {
				this.code = r.code;
				this.render();
				this.initCommon();
			} else {
				this.retryTimer = setTimeout(() => this.updateCode(), 1000);
			}
		}).catch(() => {
			if (this.cancelCodeUpdate) return;
			this.retryTimer = setTimeout(() => this.updateCode(), 1000);
		})
	}

	render()
	{
		let creditsCalculated = this.credits;
		let code = this.code;
		let item = this.manager.getItem("phone_hu", this.credits);
		let phoneno = this.manager.formatPhone(item.phone);
		let formattedPrice = this.manager.formatPrice(item.price, item.currency);
		let netFormattedPrice = this.manager.formatPrice(item.price / 1.27, item.currency);

		let $module = this.tmpl.render(
			"topup-module-phone-hu",
			{creditsCalculated, formattedPrice, netFormattedPrice, phoneno, code});

		this.$root.empty().append($module);

		$module.find(".sxcct-support").click((e) => {
			e.preventDefault();
			let url = "/contact";
			window.open(url, '_blank');
		})
	}

	destroy()
	{
		clearTimeout(this.retryTimer);
		super.destroy();
	}
}

export class TopupPanelModuleSmsHu extends TopupPanelModule
{
	init()
	{
		let creditsCalculated = this.credits;
		let item = this.manager.getItem("sms_hu", this.credits);
		let formattedPrice = this.manager.formatPrice(item.price, item.currency);
		let code = this.manager.getData("sms_hu").code;
		let phoneno = this.manager.formatPhone(item.phone);
		let netFormattedPrice = this.manager.formatPrice(item.price / 1.27, item.currency);

		let $module = this.tmpl.render(
			"topup-module-sms-hu",
			{creditsCalculated, formattedPrice, netFormattedPrice, phoneno, code});

		this.$root.empty().append($module);

		$module.find(".sxcct-support").click((e) => {
			e.preventDefault();
			let url = "/contact";
			window.open(url, '_blank');
		})
	}
}

export class TopupPanelModuleAlternative extends TopupPanelModule
{
	init()
	{
		let creditsCalculated = this.credits;
		let item = this.manager.getItem("alternative", this.credits);
		let formattedPrice = this.manager.formatPrice(item.price, item.currency);

		let $module = this.tmpl.render(
			"topup-module-alternative",
			{creditsCalculated, formattedPrice});

		this.$root.empty().append($module);

		this.$root.find(".sxcct-window-buttons button").click(() => {
			window.open(this.manager.getData("alternative").url + "?amount=" + this.credits , '_blank');
			this.onClose();
		})
	}
}

class TopupPanelPicker
{
	private TAG = "[Sxc.Chat.TopupPanelPicker]";

	private $leftArrow: JQuery;
	private $rightArrow: JQuery;
	private $items: JQuery;
	private $item: JQuery;
	private currentMethod: string;

	public constructor(private $root: JQuery,
	                   private tmpl: TemplateEngine,
	                   private manager: TopupManager,
	                   private toast: ToastManager,
	                   private t: Translator,
	                   private promo : Promo,
	                   private defaultMethod : string,
	                   private onPick: (method: string, amount: number) => void,
	                   private onClose: () => void,
					   private needFirstCredit:Boolean = false
			)

	{
		let methods : any = this.manager.getMethods();

		if(this.needFirstCredit === false) {
			methods= methods.filter(function(value, index, arr){
				return value !== "firstcredit";
			});
		}

		methods = methods.map((m) => {
			return {
				id: m,
				tooltip: "topup_method_shortname_" + m
			};
		});

		if (this.manager.isQuickBuyEnabled()) {
			methods.unshift({id: "quickbuy", tooltip: "topup_method_shortname_quickbuy"})
		}

		let $picker = this.tmpl.render(
			"topup-picker",
			{methods});

		this.$root.empty().append($picker);

		let $methods = this.$root.find(".sxcct-method");

		$methods.click((e) =>
		{
			let id = $(e.currentTarget).attr("data-id");
			if (id == "close") {
				this.onClose();
			} else {
				this.pickMethod(id);
			}
		});

		$.ajax({
			method: 'GET',
			url: 'https://sexchat.hu/ajax/api/getTopupCount?id='+(manager.app.options.auth.memberID ? manager.app.options.auth.memberID : 0),
			dataType: 'json'
		}).done((data) => {
			if(data.success != true || data.count != 0) { return; }

			$.each($methods, (itemIndex, methodItem) => {
				let methodObj       = $(methodItem);
				let methodObjDataId = $(methodObj).data('id');

				if(methodObjDataId != 'firstcredit' && methodObjDataId != 'creditcard' && methodObjDataId != 'sms_hu' && methodObjDataId != 'close') {
					methodObj.hide();
				}
			});
		});

		// let methodNameUpdateTimer = null;
		//
		// $methods.mouseenter((e) => {
		// 	let id = $(e.currentTarget).attr("data-id");
		// 	if (id !== "close") {
		// 		methodNameUpdateTimer = setTimeout(() => {
		// 			let title = this.t.t("topup_method_longname_" + id);
		// 			this.$root.find(".sxcct-amt-title").text(title);
		// 		}, 1000);
		// 	}
		// });
		//
		// $methods.mouseleave(() => {
		// 	clearTimeout(methodNameUpdateTimer);
		// 	let title = this.t.t("topup_method_longname_" + this.currentMethod);
		// 	this.$root.find(".sxcct-amt-title").text(title);
		//
		// });

		if (defaultMethod) {
			this.pickMethod(defaultMethod);
		} else {
			this.pickMethod(methods[0].id);
		}
	}

	destroy()
	{
		this.$root.empty();
	}

	public pickMethod(method: string)
	{
		logging.log(this.TAG, "pickMethod", method, this);

		this.currentMethod = method;

		this.scrollOffset = 0;

		this.$root.find(".sxcct-method").removeClass("sxc-selected");
		this.$root.find(".sxcct-method[data-id=" + method + "]").addClass("sxc-selected");

		// let data = this.manager.getData(method);

		let items = [];
		let ia = 1;

		const sourceItems = method === "quickbuy"
			? this.manager.getData("creditcard").items
			: this.manager.getData(method).items;

		for (let i of sourceItems)
		{
			let item : any = {
				credits: i.credit,
				calculatedCredits: i.credit,
				formattedPrice: this.manager.formatPrice(i.price, i.currency),
			};

			if (this.promo && (method === "creditcard" || method === "quickbuy")) {
				item.promoType = this.promo.type;
				item.promoName = this.promo.name;
				item.isDiscount = this.promo.type == "discount";
				item.isExtraCredit = this.promo.type == "extraCredit";

				if (item.isExtraCredit) {
					item.calculatedFinalCredits = i.credit + this.promo.getAmount(i.credit);
					item.formattedFinalPrice = item.formattedPrice;
					item.promoName = this.t.t("topup_promo_" + this.promo.name);
				}
			} else if(method == "firstcredit") {
				item.promoType = "firstcredit";
				item.isFirstCredit = true;

				switch (i.credit) {
					case 1000: item.extraCredit = 150; break;
					case 2500: item.extraCredit = 500; break;
					case 5000: item.extraCredit = 1500; break;
					case 10000: item.extraCredit = 3000; break;
					default: continue;
				}
				item.originalCredits = i.credit;
				item.calculatedCredits = i.credit + item.extraCredit;
			} else {
				item.calculatedFinalCredits = item.calculatedCredits;
				item.formattedFinalPrice = item.formattedPrice;
			}

			items.push(item)
		}

		logging.log(this.TAG, "pickMethod", items);

		let title = this.t.t("topup_method_longname_" + method);

		let $amounts = this.tmpl.render(
			"topup-picker-amounts",
			{title, items});

		this.$root.find(".sxcct-amt-cnt").empty().append($amounts);

		this.$items = this.$root.find(".sxcct-amt-items");
		this.$item = this.$items.find(".sxcct-amt-item");

		this.$leftArrow = this.$root.find(".sxcct-amt-left");
		this.$rightArrow = this.$root.find(".sxcct-amt-right");

		this.$leftArrow.click(() => this.scroll(-1));
		this.$rightArrow.click(() => this.scroll(1));

		this.$item.click((e) =>
		{
			let credits = parseInt($(e.currentTarget).data("id"), 10);
			this.onPick(method, credits);
		});

		if (method === "quickbuy") {
			this.$item.mouseenter((e) => {
				let credits = parseInt($(e.currentTarget).data("id"), 10);

				let credit = this.promo
					? credits + this.promo.getAmount(credits)
					: credits;

				const msg = this.t.t(
					"mode_bar_amount_toast",
					{amount: credit});

				this.toast.push(msg, {timeout: 5000, instant: true});
			});
		}

		this.onResize();
	}

	private itemsVisible;
	private itemsCount;
	private scrollOffset = 0;

	public onResize()
	{
		let canvasWidth = Math.floor(this.$root.width());
		let availableWidth = canvasWidth - 2 * this.$leftArrow.width();
		let itemWidth = 175; // $item.width();
		let itemsVisible = Math.floor(availableWidth / itemWidth);

		this.itemsVisible = itemsVisible;
		this.itemsCount = this.$item.length;

		let newWidth = itemWidth * Math.min(this.itemsCount, itemsVisible);
		this.$items.css({width: newWidth});

		this.updateArrows();

		// logging.log(this.TAG, "onResize", canvasWidth, availableWidth, itemWidth, itemsVisible, newWidth)
	}

	private updateArrows()
	{
		if (this.scrollOffset > 0) {
			this.$leftArrow.addClass("sxc-visible");
		} else {
			this.$leftArrow.removeClass("sxc-visible");
		}

		if (this.itemsVisible + this.scrollOffset < this.itemsCount) {
			this.$rightArrow.addClass("sxc-visible");
		} else {
			this.$rightArrow.removeClass("sxc-visible");
		}
	}

	private scroll(d)
	{
		let shift;

		if (d == 1) {
			shift = Math.min(this.itemsVisible, this.itemsCount - this.itemsVisible - this.scrollOffset);
			logging.log(this.TAG, "scrollOffset", this.scrollOffset, shift);
			this.scrollOffset += shift;
		}
		else {
			shift = Math.min(this.itemsVisible, this.scrollOffset);
			logging.log(this.TAG, "scrollOffset", this.scrollOffset, shift);
			this.scrollOffset -= shift;
		}

		this.$items.animate({scrollLeft: this.$item.width() * this.scrollOffset}, 500 * shift);
		this.updateArrows();
	}

}

export class TopupPanel
{
	private TAG = "[Sxc.Chat.TopupPanel]";

	private selectedMethod = null;
	private selectedCredits = null;
	private step: string;

	private picker: TopupPanelPicker;
	private module: TopupPanelModule;
	private promo: Promo;
	public event : Collection;

	public needFirstCredit : boolean = false;
	public needFirstZeroCredit : boolean = false;

	public constructor(private $root: JQuery,
	                   private tmpl: TemplateEngine,
	                   private manager: TopupManager,
	                   private toast: ToastManager,
	                   private t: Translator,
	                   private view: ChatClientUI,
	                   private storage: Storage)
	{
		this.event = new Collection("topuppanel");
	}

	public isVisible()
	{
		return this.$root.is(":visible");
	}

	public show(show: boolean = true, method : string = null, credits : number = null, special : any = null)
	{
		logging.log(this.TAG, "show", show, method, credits, special);

		this.view.showCovers(!show);
		this.$root[show ? "addClass" : "removeClass"]("sxc-visible");

		if (show) {
			if (method && credits) {
				this.onPick(method, credits, special);
			} else {
				this.showPicker(method);
			}
		} else {
			this.step = null;
			if (this.module) {
				this.module.destroy();
				this.module = null;
			}
		}

		if(this.needFirstCredit === true && this.needFirstZeroCredit==false) {
			this.needFirstCredit = false;
			this.needFirstZeroCredit = false;

			this.$root.find('.sxcc-icon-topup-firstcredit').parent().show();

			this.$root.find('.sxcc-icon-topup-firstcredit').parent().trigger('click');
		}else if(this.needFirstZeroCredit === true) {
			this.needFirstZeroCredit = false;
			this.needFirstCredit = false;

			this.$root.find('.sxcc-icon-topup-firstcredit').parent().show();
			this.$root.find('.sxcc-icon-topup-firstcredit').parent().trigger('click');

			this.$root.find('.sxcct-methods').hide();
			this.$root.find('.sxcct-amt-title').text(this.t.t("topup_firstzerocredit_title"));
			this.$root.find('.sxcct-amt-title').before('<div class="sxcct-amt-img"></div>');
			this.$root.find('.sxcct-picker').after('<div class="sxcc-bottomtext"><a href="#" onclick="$(\'.sxcct-methods\').show();$(\'.sxcc-bottomtext,.sxcct-amt-img\').hide();"></a></div>');
			this.$root.find('.sxcc-bottomtext a').text(this.t.t("topup_firstzerocredit_bottomtext"));
		} else {
			this.$root.find('.sxcc-icon-topup-firstcredit').parent().hide();

			this.$root.find('.sxcc-icon-topup-creditcard').parent().trigger('click');
		}
	}

	public toggle()
	{
		logging.log(this.TAG, "toggle");
		this.show(!this.isVisible());
	}

	private reset()
	{
		this.selectedMethod = null;
		this.selectedCredits = null;

		if (this.module) {
			this.module.destroy();
			this.module = null;
		}

		if (this.picker) {
			this.picker.destroy();
			this.picker = null;
		}

	}

	private showPicker(defaultMethod : string = null)
	{
		logging.log(this.TAG, "showPicker", this.selectedMethod);
		this.step = "picker";

		if (this.module) {
			this.module.destroy();
			this.module = null;
		}

		this.picker = new TopupPanelPicker(
			this.$root,
			this.tmpl,
			this.manager,
			this.toast,
			this.t,
			this.promo,
			defaultMethod,
			this.onPick.bind(this),
			() => this.show(false),
			this.needFirstCredit
		);

		if (this.selectedMethod) this.picker.pickMethod(this.selectedMethod);
	}

	private onPick(method: string, credits: number, special : any)
	{
		this.selectedMethod = method;
		this.selectedCredits = credits;

		if (this.picker) {
			this.picker.destroy();
			this.picker = null;
		}

		this.step = "module";

		let module;

		switch (method) {
			case "creditcard":
				module = TopupPanelModuleCreditCard;
				break;

			case "firstcredit":
				module = TopupPanelModuleFirstCredit;
				break;

			case "creditcard-e":
				module = TopupPanelModuleCreditCardE;
				break;

			case "quickbuy":
				module = TopupPanelModuleQuickBuy;
				break;

			case "phone_hu":
				module = TopupPanelModulePhoneHu;
				break;

			case "sms_hu":
				module = TopupPanelModuleSmsHu;
				break;

			case "cryptocurrency":
				module = TopupPanelModuleCryptoCurrency;
				break;

			case "alternative":
				module = TopupPanelModuleAlternative;
				break;
		}

		if (!special && this.promo && this.promo.name === "echh") {
			special = {echh: this.promo.getAmount(credits)}
		}

		if (method == "firstcredit") {
			switch (credits) {
				case 1000: special = {firstcredit: 150}; break;
				case 2500: special = {firstcredit: 500}; break;
				case 5000: special = {firstcredit: 1500}; break;
				case 10000: special = {firstcredit: 3000}; break;
			}
		}

		if (this.module) {
			this.module.destroy();
			this.module = null;
		}

		if (module) {
			this.module = new module(
				this.$root,
				this.tmpl,
				this.manager,
				this.toast,
				this.t,
				this.storage,
				this.event,
				credits,
				special,
				() =>
				{
					this.module.destroy();
					this.module = null;
					this.show(false);
				}
			);

			this.module.init();
			this.module.initCommon();
		}
		else
		{
			throw new Error("Unsupported payment method selected: " + method)
		}
	}

	public onResize()
	{
		// logging.log(this.TAG, "onResize", "step:", this.step);
		if (this.step === "picker") {
			this.picker.onResize();
		} else if (this.step === "module") {
			this.module.onResize();
		}
	}

	public esc()
	{
		logging.log(this.TAG, "esc", "step:", this.step);
		if (this.step !== "picker") {
			this.showPicker();
		} else {
			this.show(false);
		}
	}

	public promoUpdated(promo : Promo)
	{
		logging.log(this.TAG, "promoUpdated", promo);
		this.promo = promo;

		if (this.step === "picker") {
			this.reset();
			this.showPicker();
		} else if (this.step === "module") {
			// this.module.updatePromo(promo);
		} else {
			// Nothing to do when the panel is not up...
		}
	}
	public promoSet(promo : Promo)
	{
		logging.log(this.TAG, "promoSet", promo);
		this.promo = promo;
	}

	pushPromo(currentPushPromo: any)
	{
		if (this.manager.isQuickBuyEnabled()) {
			this.manager.getSecurionPayHandler().doQuickBuy(currentPushPromo.credits, {ecp: currentPushPromo.extraCredits}, (success, data) =>
			{
				this.event.trigger("topup_attempt");

				if (success) {
					this.event.trigger("topup_successful");
					this.toast.push(data, {timeout: 7000, instant: true});
				} else {
					this.event.trigger("topup_failed");
					this.toast.push(data, {timeout: 7000, instant: true, strong: true});
				}
			});
		} else {
			this.show(true);
			this.onPick("creditcard", currentPushPromo.credits, {ecp: currentPushPromo.extraCredits})
		}
	}
}
